import customer$1 from './v1/index.js';
import './v1/profile.js';
import './v1/accounts.js';
import './v1/legal.js';

function customer(backendAxiosInstance) {
  return {
    v1: customer$1(backendAxiosInstance)
  };
}

export { customer as default };
//# sourceMappingURL=index.js.map
